import { useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { guardarProgreso } from '../api/consultas'
import { hayPendientes, sincronizarProgreso } from '../lib/offline'

/**
 * Aviso de que no hay red, y sincronizacion de lo que quedo pendiente.
 *
 * Al leer sin conexion el progreso se apunta en el telefono; en cuanto
 * vuelve la red se envia al servidor para no perder por donde ibas.
 */
export default function SinConexion() {
  const clienteConsultas = useQueryClient()
  const [conectado, setConectado] = useState(navigator.onLine)
  const [sincronizando, setSincronizando] = useState(false)

  useEffect(() => {
    async function alConectar() {
      setConectado(true)
      if (!hayPendientes()) return

      setSincronizando(true)
      const enviados = await sincronizarProgreso((id, pagina, leido) =>
        guardarProgreso(id, pagina, leido || undefined),
      )
      setSincronizando(false)

      if (enviados > 0) {
        void clienteConsultas.invalidateQueries({ queryKey: ['biblioteca'] })
      }
    }

    function alDesconectar() {
      setConectado(false)
    }

    window.addEventListener('online', alConectar)
    window.addEventListener('offline', alDesconectar)
    // Tambien al arrancar: la app puede abrirse tras haber leido sin red
    if (navigator.onLine) void alConectar()

    return () => {
      window.removeEventListener('online', alConectar)
      window.removeEventListener('offline', alDesconectar)
    }
  }, [clienteConsultas])

  if (conectado && !sincronizando) return null

  return (
    <div className={conectado ? 'aviso-red sincronizando' : 'aviso-red'}>
      {conectado ? (
        'Sincronizando tu progreso…'
      ) : (
        <>
          Sin conexion · <Link to="/descargas">ver lo descargado</Link>
        </>
      )}
    </div>
  )
}
